jQuery(function ($) {
  $('.about__tabList li').click(function () {
    var index = $(this).index();
    $('.about__tabList li').removeClass('is_active');
    $(this).addClass('is_active');
    $('.about__tabBox').removeClass('is_show').eq(index).addClass('is_show');
  });

  // 外部からタブを選択
  var url = $(location).attr('href');
  if (url.indexOf("?tab=") != -1) {
    var id = url.split("?tab=");
    var tab_id = id[id.length - 1].slice(0, 1);
    $('.about__tabList li').eq(tab_id).click();
  }
});
